/**
 * 设备管理
 */
export default {
  // deleteCompanyEquipment: "/companyEquipment/deleteCompanyEquipment", //   删除
  // insertCompanyEquipment: "/companyEquipment/insertCompanyEquipment", //   新增
  // selectCompanyEquipmentDetail: "/companyEquipment/selectCompanyEquipmentDetail", //   详情
  // selectCompanyEquipmentList: "/companyEquipment/selectCompanyEquipmentList", //   设备列表
  // selectCompanyOfficesList: "/companyEquipment/selectCompanyOfficesList", //   门店列表
  // updateCompanyEquipment: "/companyEquipment/updateCompanyEquipment", //   修改

  equipmentInfodelete: '/equipmentInfo/delete', // 删除设备/{id}
  equipmentInfoinsert: '/equipmentInfo/insert', // 新增设备
  equipmentInfoselect: '/equipmentInfo/select', // 查询设备
  equipmentInfoupdate: '/equipmentInfo/update', // 修改设备
}